<template>
  <div id="SingleSelectQuestion" class="border-brand-primary">
    <button
      class="dmh-option clickable"
      v-for="(option, i) in question.options"
      @click="selectOptionIndex(i, option.option_text)"
      :class="{ active: selectedOptionText === option.option_text }"
      :key="i"
    >
      <div class="dmh-option-top">
        <div v-if="getClass(option.option_text)" class="dmh-option-icon brand-primary mr-4">
          <i :class="getClass(option.option_text)"></i>
        </div>
        <div class="dmh-option-text">{{ option.option_text }}</div>
      </div>
      <p v-if="option.description" class="text-description">{{ option.description }}</p>
      <p v-if="option.option_sub_text" class="text-description">{{ option.option_sub_text }}</p>
    </button>
    <p v-if="question.footer_text" class="text-description text-center">{{ question.footer_text }}</p>
  </div>
</template>

<script>

export default {
  name: "SingleSelectQuestion",
  props: ["question", "answer", "setAnswer", "onNavigate"],
  data() {
    return {
      selectedOptionText: this.answer || null
    };
  },
  mounted() {
    if (this.answer) {
      const selectedOptionIndex = this.question.options.findIndex(
        (option) => option.option_text === this.answer
      );
      if (selectedOptionIndex !== -1) {
        this.setAnswer(selectedOptionIndex);
      } else {
        this.setAnswer(null);
      }
    }
  },
  methods: {
    selectOptionIndex(i, optionText = "") {
      this.selectedOptionText = optionText;
      this.setAnswer(i);
      if (this.question.question_text === "Set your clinician preference") {
        this.$emit('setGenderPreference', this.selectedOptionText)
      }
      if (optionText.includes("I'd like to learn more about the service")) {
        this.onNavigate?.("/learn-more");
      }
    },
    getClass(text) {
      switch (text) {
        case "I'd like to talk to someone about my mental health.":
          return "fa-solid fa-head-side-virus";
        case "I'd like to learn more about the service.":
          return "fa-solid fa-book-open-reader";
        case "Financial Information":
          return "fa-solid fa-balance-scale";
        case "Legal Information":
          return "fa-solid fa-book-open-reader";
        case "I'd like to learn more about mental health and Wellbeing.":
          return "fa-solid fa-heart-pulse";
        case "I'd like to get access another service like financial or legal.":
          return "fa-solid fa-coins";
        default:
          return "";
      }
    }
  }
};
</script>
<style lang="less">
#SingleSelectQuestion {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 650px;
  width: 100%;

  .text-description {
    font-family: var(--font-regular, "DMSans");
    color: #1e1e22;
    font-size: 1.6rem;
    margin: 4px 0 0;
    padding: 0;
  }

  .dmh-option-top {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    align-items: center;
  }

  .dmh-option {
    display: flex;
    flex-direction: column;
    background-color: white;
    color: #1e1e22;
    max-width: 800px;
    width: 100%;
    padding: 24px;
    border-radius: 20px;
    border: 2px solid #aeb0bd;
    text-align: left;

    &:hover,
    &.active {
      border: 2px solid var(--brand-primary);
    }

    .dmh-option-text {
      font-family: var(--font-bold, "DMSans Bold");
      font-size: 1.6rem;
      width: 100%;
    }

    .brand-primary {
      .fa-solid {
        color: inherit !important;
      }
    }

    .fa-solid {
      font-size: 4rem;
      color: lightgrey;
    }

    .fa-regular {
      font-size: 4rem;
      color: lightgrey;
    }
  }
}
</style>
